/**
 * Social-media-post detail/row actions.
 *
 * Kept intentionally small (mirrors the read-mostly contracts action set):
 * View details, Change status, Ask Meridian, and admin Delete. Publishing /
 * scheduling is driven by the marketing pipeline, not these CRM actions.
 */

import type { DetailActionStrict } from "@/lib/actions/types/detail-action";
import {
  universalDeleteAction,
  universalViewDetailsAction,
  universalAskMeridianAction,
} from "@/lib/actions/definitions/universal-actions";
import { createStatusAction } from "@/lib/actions/definitions/shared/status-actions";
import { ROLE_COMBINATIONS } from "@/lib/actions/types/action-properties";
import type { EntityRowType } from "@/lib/actions/types/entity-keys";

/** The social-media-post row type the action registry expects for the key. */
type SocialMediaPostRow = EntityRowType<"social_media_posts">;

export const socialMediaPostDetailActions: DetailActionStrict<SocialMediaPostRow>[] = [
  // TABLE-ONLY ACTION
  universalViewDetailsAction<SocialMediaPostRow>("viewDetails"),

  // SECONDARY ACTIONS
  createStatusAction<SocialMediaPostRow>({
    label: "Change Status",
    primary: false,
    allowedRoles: [...ROLE_COMBINATIONS.EMPLOYEE_AND_ADMIN],
  }),
  universalAskMeridianAction<SocialMediaPostRow>(),
  universalDeleteAction<SocialMediaPostRow>(),
];
